export enum CvDatabaseAccessTokenRequestStatus {
  Pending = 1,
  DemoViewLimitReached = 2, //when all tokens reach demo view limit
  Approved = 3,
  Rejected = 4,
  Terminated = 5,
  ViewLimitReached = 6, //when all tokens reach view limit
  Expired = 7, //when all tokens expire
}
